var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.33301C6.25334 1.33301 4.83334 2.75301 4.83334 4.49967C4.83334 6.21301 6.17334 7.59967 7.92001 7.65967C7.97334 7.65301 8.02668 7.65301 8.06668 7.65967C8.08001 7.65967 8.08668 7.65967 8.10001 7.65967C8.10668 7.65967 8.10668 7.65967 8.11334 7.65967C9.82001 7.59967 11.16 6.21301 11.1667 4.49967C11.1667 2.75301 9.74668 1.33301 8.00001 1.33301Z",
    fill: "#444656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3867 9.43293C9.52667 8.19293 6.49334 8.19293 4.62 9.43293C3.77334 9.9996 3.30667 10.7663 3.30667 11.5863C3.30667 12.4063 3.77334 13.1663 4.61334 13.7263C5.54667 14.3529 6.77334 14.6663 8 14.6663C9.22667 14.6663 10.4533 14.3529 11.3867 13.7263C12.2267 13.1596 12.6933 12.3996 12.6933 11.5729C12.6867 10.7529 12.2267 9.99293 11.3867 9.43293Z",
    fill: "#444656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.3b2b7f557d97a5d8885032fd020a4568.svg";
export { ForwardRef as ReactComponent };